module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-lines-fill-2824a56c.svg";